import { Controller } from '@hotwired/stimulus';

export default class MediaTeachingApplicationsStatusController extends Controller {
  static targets = [
    'deleteButton',
    'checkbox',
  ];

  connect() {
    this.toggleDeleteButton();
  }

  toggleDeleteButton() {
    const isChecked = this.checkboxTargets.some(checkbox => checkbox.checked);
    this.deleteButtonTarget.disabled = !isChecked;
  }
}